import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class GetFinancialBlockMetricsDataRequest extends BaseServiceRequest {
  constructor(payload) {
    super();
    super.addRequestUri("financialMetrics");
    super.addRequestParameter("stock_symbol", payload.symbol);
    if (payload.quarter) {
      super.addRequestParameter("fiscal_quarter", payload.quarter);
    }
    super.addRequestParameter("fiscal_year", payload.year);
    super.addRequestParameter("data_item", payload.metrics);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }
}

export default GetFinancialBlockMetricsDataRequest;
